/**
 * @param {HTMLLinkElement} link
 */
export function initTextLink(link) {
    // add content if not data-content is not set
    if (!link.dataset.content) {
        link.setAttribute("data-content", link.textContent);
    }
}
